<!--
 * @Description:
-->
<template>
    <div>
      <!-- 顶部图片 -->
      <div class="top-pic">
        <img src="../../assets/contact/message-banner.png" alt="">
      </div>
      <div class="content" >
        <div class="content-center">
          <div class="title">在线留言</div>
          <div class="content_detail">
            <div class="formData clearfix">
              <el-form v-if="!success" ref="feedback" :model="feedback" label-width="120px" :rules="rules"     v-loading="loading">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="feedback.name" placeholder="请输入姓名"></el-input>
                </el-form-item>

                <el-form-item label="手机号码" prop="phone">
                  <el-input v-model="feedback.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>

                <el-form-item label="内容" prop="content">
                  <el-input rows="6"  type="textarea" v-model="feedback.content" placeholder="请输入内容"></el-input>
                </el-form-item>
                  <el-form-item prop="code">
                    <el-input
                        v-model="feedback.code"
                        placeholder="验证码"
                    >
                      <i slot="prefix"> <img src="@/assets/icon/code.png"></i>
                      <div slot="suffix">
                        <!-- 验证码组件 -->
                        <div class="login-code" @click="refreshCode">
                          <s-identify :identifyCode="identifyCode" :contentWidth="80" :contentHeight="40"></s-identify>
                        </div>
                      </div>
                    </el-input>
                  </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">确认</el-button>
                </el-form-item>
              </el-form>
              <span v-if="success">您的留言已收到，我们会尽快联系你！</span>
        </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import request from "@/util/request";
  import SIdentify from '@/components/SIdentify'

  export default {
    components:{
      SIdentify
    },
    data() {
      const validateCode = (rule, value, callback) => {
        if (this.identifyCode !== value) {
          this.refreshCode()
          callback(new Error('验证码错误'))
        } else {
          callback()
        }
      }
      return {
        success:false,
        identifyCode: "",
        loading:false ,
        feedback: {
          name: null,
          phone: null,
          content: null
        },
        rules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          phone: [
            {required: true, message: '请输入', trigger: 'blur'},
            { pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入正确手机号/电话号", trigger: "blur" }
          ],
          content: [
            {required: true, message: '请输入留言内容', trigger: 'blur'},
            {min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur'}
          ],
          code: [
            { required: true, trigger: "blur", message: "请输入验证码" },
            { validator: validateCode, trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      // 验证码
      this.refreshCode();
      },
    methods:{
      //验证码
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },
      refreshCode() {
        this.identifyCode = "";
        // 获取随机数
        let codes = '0123456789';
        for (let i = 0; i < 4; i++) {
          this.identifyCode += codes[this.randomNum(0, codes.length)];
        }
      },
      onSubmit(){
        this.$refs['feedback'].validate((valid) => {
          if (valid) {
            this.loading = true
            request.post('/feedback/add',this.feedback).then(res=>{
              this.success = true
              console.log(res)
            }).finally(()=>this.loading=false)
          }
          else {
            return ;
          }
        });

      }
    }
  }
  </script>
  <style lang="css" scoped>
  .top-pic {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .top-pic img {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-center {
    width: 1000px;
  }
  .title {
    font-size: 20px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 24px;
    border-bottom: 1px solid #eeeeee;
  }
  .content_detail {
    margin-top: 77px;
    padding-left: 10px;
  }
  .content_detail p {
    width: 1015px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .content_detail h4 {
    margin-top: 77px;
  }
  .content_detail li {
    margin-top: 77px;
  }
  .tel {
    font-weight: bold;
    line-height: 30px;
    margin-top: 77px;
    margin-bottom: 77px;
  }
  .formData {
    padding-bottom: 50px;
}

.formData .item {
    float: left;
    color: #999;
    font-weight: normal;
    width: 380px;
    height: 45px;
    line-height: 45px;
    border: 1px solid #e4e4e4;
    margin-right: 75px;
    margin-bottom: 25px;
    position: relative;
    box-sizing: border-box;
}

.formData .item label {
    padding-left: 15px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 11;
    text-align: center;
    display: block;
    margin: 0;
    height: 43px;
    line-height: 43px;
    font-size: 18px;
    color: #666;
}

.formData .item input {
    outline: none;
    line-height: 38px;
    height: 38px;
    font-size: 18px;
}

.formData .item .txt {
    width: 100%;
    height: 43px;
    line-height: 43px;
    display: block;
    background: none;
    padding-left: 70px;
    border: 0 none;
    color: #666;
    box-sizing: border-box;
}

.formData .item .red {
    position: absolute;
    right: 15px;
    top: 0;
    color: #ff0000;
    z-index: 11;
}

.formData .item.mr0 {
    margin-right: 0;
}

.formData .msg-box {
    position: absolute;
    left: 0;
    top: 0px;
}

.formData .liuyan {
    width: 100%;
    height: 260px;
    border: 1px solid #e4e4e4;
    float: left;
}

.formData .liuyan label {
    text-align: right;
    display: block;
    top: 7px;
}

.formData .liuyan textarea {
    width: 100%;
    height: 234px;
    line-height: 35px;
    padding: 12px 10px;
    text-indent: 100px;
    font-size: 18px;
    font-family: "microsoft yahei";
    color: #666;
    border: 0 none;
    overflow: hidden;
    background: none;
    resize: none;
    display: block;
    outline: none;
    box-sizing: border-box;
}

.formData .bot {
    width: 100%;
}

.formData .sub {
    float: right;
    width: 232px;
    line-height: 42px;
    border: 2px solid#53CABE;
    margin-right: 2px;
    text-align: center;
    background:#53CABE;
    color: #FFF;
    cursor: pointer;
    font-size: 18px;
    display: block;
    outline: none;
    transition: all .5s;
}

.formData .sub:hover {
    background: none;
    color:#53CABE;
}

.formData .yzm .txt {
    padding-left: 80px;
}

.formData .yzm img {
    position: absolute;
    right: 0;
    top: 0;
    border: 0;
    display: block;
}
  </style>
